import { createApp } from 'vue'
import './style.css'
import App from './App.vue'

const app = createApp(App)

// Global error handler to surface crashing computeds and their component context
app.config.errorHandler = (err, instance, info) => {
  // eslint-disable-next-line no-console
  console.error('[Vue error]', info, 'in', instance?.$options?.__name ?? instance?.$?.type?.__name ?? 'unknown', err)
}

app.mount('#app')
